import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { fromSecondsToTimeSpanString, fromTimeSpanStringToSeconds, subscribeToDurationChanges } from 'src/app/libs/utils';
import { AttendanceEntry, TId } from 'src/app/models';
import { GenericResource } from 'src/app/resources';
import { AlertService } from 'src/app/services/alert.service';
import { MasterApiService } from 'src/app/services/master-api.service';

@Component({
  selector: 'app-hr-attendance-entries-edit-popup',
  standalone: false,
  templateUrl: './hr-attendance-entries-edit-popup.component.html',
  styleUrl: './hr-attendance-entries-edit-popup.component.sass'
})
export class HrAttendanceEntriesEditPopupComponent implements OnInit {

  resource?: GenericResource<AttendanceEntry>;
  form?: FormGroup;
  attendanceTime: string | undefined = undefined;

  @Input() id?: TId;
  @Input() entity?: AttendanceEntry;
  @Output() edited: EventEmitter<AttendanceEntry> = new EventEmitter<AttendanceEntry>();

  constructor(private api: MasterApiService, private fb: FormBuilder, private alertSvc: AlertService) { }

  async ngOnInit(): Promise<void> {
    this.resource = this.api.resources.attendanceEntriesMe;

    try {
      if (this.entity && !this.id) {
        this.id = this.entity.id;
      }

      if (this.resource && this.id) {
        const fetchedEntity = await firstValueFrom(this.resource.get(this.id));

        if (this.entity) {
          this.entity = this.mergeBackendEntity(this.entity, fetchedEntity);
        } else {
          this.entity = fetchedEntity;
        }
      }
    } catch (error) {
      this.alertSvc.error('Error fetching attendance entry data');
      throw error;
    }

    this.form = this.initFormGroup();
    subscribeToDurationChanges(this.form, 'entryIn', 'entryOut', 'attendanceTime');
  }

  protected mergeBackendEntity(base: Partial<AttendanceEntry>, patch?: Partial<AttendanceEntry>): AttendanceEntry {
    const result: any = { ...base };

    for (const [key, value] of Object.entries(patch ?? {})) {
      if (value !== null && value !== undefined) {
        result[key] = value;
      }
    }

    return result as AttendanceEntry;
  }

  initFormGroup(): FormGroup {
    this.attendanceTime = fromSecondsToTimeSpanString(this.entity!.attendanceTime);
    const attendanceEntry: AttendanceEntry = this.entity!;
    const group = this.fb.group({
      id: [attendanceEntry.id],
      workerName: [attendanceEntry.workerName],
      entryIn: [attendanceEntry.entryIn],
      entryOut: [attendanceEntry.entryOut],
      attendanceTime: [this.attendanceTime],
      incidence: [attendanceEntry.incidence],
    });
    return group;
  }

  async submit(): Promise<void> {
    const entrie: AttendanceEntry = this.form!.value;
    entrie.companyId = this.api.auth.userValue!.lastCompanyId;
    entrie.attendanceTime = fromTimeSpanStringToSeconds(this.form!.value.attendanceTime);

    try {
      const result = await firstValueFrom(this.resource!.put(entrie)!);
      this.edited.emit(result);

    } catch (exception: { error: { message: string } } | any) {
      this.alertSvc.error(exception.error.message);
      throw exception;
    }
  }
}
